import e from "./highrise1526.mjs";
import u from "./highrise648.mjs";
function l(r, s, t) {
  var a = s(r);
  return u(r) ? a : e(a, t(r));
}
export {
  l as default
};
